import React from "react";
import {
    TextField,
    Button,
    Grid,
    Paper,
    Typography,
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    styled,
    Avatar,
    FormHelperText,
    CircularProgress
} from "@mui/material";
/* import PersonAddIcon from "@mui/icons-material/PersonAdd"; */
import { useUserRegister } from "./UseRegister";
/* import FullScreenLoading from "../../components/loading/FullScreenLoading"; */

const BootstrapButton = styled(Button)({
    borderRadius: "35px",
    backgroundColor: "#0D85B3",
    height: "4em",
});

const UserRegister: React.FC = () => {
    const {
        formData,
        errors,
        loading,
        handleChange,
        handleSubmit,
        handleChangeSelect,
    } = useUserRegister();

    return (
        <>
        <Box
            sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            bgcolor: "#f5f5f5",
            }}
        >
            <Paper
            elevation={3}
            sx={{
                p: 3,
                width: { xs: "95%", sm: 600 },
                borderRadius: 3,
                margin: 1,
            }}
            >
            <Box display="flex" justifyContent="center" mb={3}>
                <Avatar sx={{ bgcolor: "secondary.main" }}>
                    
                </Avatar>
            </Box>
            <Typography variant="h5" fontWeight="bold" textAlign="center" mb={2}>
                Registro de Usuario
            </Typography>

            <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                    <Grid  size={{ xs: 6, md: 12 }}>
                        <TextField
                        fullWidth
                        label="Nombre"
                        name="nombre"
                        value={formData.nombre}
                        onChange={handleChange}
                        error={!!errors.nombre}
                        helperText={errors.nombre}
                        />
                    </Grid>
                    <Grid size={{ xs: 6, md: 12 }}>
                        <TextField
                        fullWidth
                        label="Apellido"
                        name="apellido"
                        value={formData.apellido}
                        onChange={handleChange}
                        error={!!errors.apellido}
                        helperText={errors.apellido}
                        />
                    </Grid>
                    <Grid size={{ xs: 6, md: 12 }}>
                        <FormControl fullWidth error={!!errors.tipoDocumento}>
                        <InputLabel id="documento-select-label">
                            Tipo de Documento
                        </InputLabel>
                        <Select
                            labelId="documento-select-label"
                            name="tipoDocumento"
                            value={formData.tipoDocumento}
                            onChange={handleChangeSelect}
                            label="Tipo de Documento"
                        >
                            <MenuItem value="DNI">DNI</MenuItem>
                            <MenuItem value="pasaporte">Pasaporte</MenuItem>
                            <MenuItem value="licencia">Licencia de conducir</MenuItem>
                            <MenuItem value="cuil">CUIL</MenuItem>
                        </Select>
                        <FormHelperText>{errors.tipoDocumento}</FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid size={{ xs: 6, md: 12 }}>
                        <TextField
                        fullWidth
                        label="Nro de Documento"
                        name="nroDocumento"
                        type="number"
                        value={formData.nroDocumento}
                        onChange={handleChange}
                        error={!!errors.nroDocumento}
                        helperText={errors.nroDocumento}
                        />
                    </Grid>
                    <Grid size={{ xs: 6, md: 12 }}>
                        <TextField
                        fullWidth
                        label="Correo Electrónico"
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        error={!!errors.email}
                        helperText={errors.email}
                        />
                    </Grid>
                    <Grid size={{ xs: 6, md: 12 }}>
                        <TextField
                        fullWidth
                        label="Fecha de Nacimiento"
                        type="date"
                        name="fechaNacimiento"
                        InputLabelProps={{ shrink: true }}
                        value={formData.fechaNacimiento}
                        onChange={handleChange}
                        error={!!errors.fechaNacimiento}
                        helperText={errors.fechaNacimiento}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 12 }}>
                        <TextField
                        fullWidth
                        label="Contraseña"
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        error={!!errors.password}
                        helperText={errors.password}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 12 }}>
                        <TextField
                        fullWidth
                        label="Confirmar Contraseña"
                        type="password"
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                        error={!!errors.confirmPassword}
                        helperText={errors.confirmPassword}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 12 }}>
                        {loading && (
                            <div className="d-flex justify-content-center align-items-center">
                                <CircularProgress />
                            </div>
                        )}
                        <Box className="d-flex align-items-center w-100 my-3">
                            <hr className="flex-grow-1" />
                            {/* <span className="mx-2">Accedé con</span> */}
                            <hr className="flex-grow-1" />
                        </Box>                       
                        
                      {/*   <Box className="d-flex gap-3 justify-content-center">
                            <Button variant="outlined">
                                <img src="img/google.png" alt="Google" width={32} />
                            </Button>
                            <Button variant="outlined">
                                <img
                                src="https://upload.wikimedia.org/wikipedia/commons/0/05/Facebook_Logo_%282019%29.png"
                                alt="Facebook"
                                width={20}
                                />
                            </Button>
                        </Box> */}
                        <BootstrapButton
                            fullWidth
                            variant="contained"
                            type="submit"                            
                        >
                            Registrarse
                        </BootstrapButton>
                    </Grid>
                </Grid>
            </form>
            </Paper>
        </Box>
        
        </>
    );
};

export default UserRegister;
